var _style, _g, _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgGraphicRecoveryKeymin = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 205,
    height: 160,
    fill: "none",
    viewBox: "30 10 175 145",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "@keyframes twinkle{0%,to{transform:scale(.9);opacity:.2}50%{transform:scale(1.1);opacity:1}}@keyframes drawCheckmark{0%,50%{stroke-dasharray:100;stroke-dashoffset:100}60%,to{stroke-dashoffset:0}}@keyframes scaleCircle{0%,40%{transform:scale(0)}60%,to{transform:scale(1)}}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5165_11763)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M139.331 60.59c-.166 0-.331.008-.496.012v-.012c0-14.685-11.884-26.59-26.543-26.59-11.904 0-21.978 7.85-25.344 18.665a18.2 18.2 0 0 0-8.505-2.103c-10.096 0-18.281 8.2-18.281 18.314 0 1.647.22 3.243.628 4.762a14.7 14.7 0 0 0-5.995-1.28C46.624 72.359 40 78.995 40 87.18S46.624 102 54.795 102h84.536C150.746 102 160 92.73 160 81.295s-9.254-20.705-20.669-20.705"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 95.135,
    cy: 102.607,
    r: 16.191,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0190ED",
    stroke: "#0190ED",
    strokeWidth: 2,
    d: "M156.752 98.074H118.33C115.995 88.302 107.318 81 96.975 81 84.84 81 75 91.039 75 103.343s9.84 22.342 21.975 22.342c11.083 0 20.139-8.399 21.648-19.208h25.593v10.738c0 2.303 1.841 4.202 4.146 4.202 2.306 0 4.147-1.899 4.147-4.202v-10.738h4.243c2.306 0 4.146-1.899 4.146-4.202s-1.84-4.2-4.146-4.2Zm-59.777 19.208c-7.528 0-13.683-6.237-13.683-13.939 0-7.703 6.155-13.94 13.683-13.94s13.682 6.237 13.682 13.94-6.155 13.939-13.682 13.939Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      animation: "twinkle 2.5s infinite ease-in-out alternate",
      transformOrigin: "152px 76px"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#DABDFF",
    fillRule: "evenodd",
    d: "M160.47 76.735a.598.598 0 0 0-.485-.6c-1.184-.215-4.454-.988-5.571-2.087s-1.872-4.37-2.079-5.571a.59.59 0 0 0-.597-.485v8.743z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#00B3F4",
    fillRule: "evenodd",
    d: "M151.774 67.992a.6.6 0 0 0-.59.502c-.2 1.177-.934 4.394-2.041 5.585s-4.394 1.883-5.655 2.108a.606.606 0 0 0-.488.6h8.781z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#00B3F4",
    fillRule: "evenodd",
    d: "M151.727 76.735v8.743a.63.63 0 0 0 .597-.503c.214-1.198.987-4.517 2.086-5.62 1.1-1.103 4.373-1.83 5.557-2.03a.594.594 0 0 0 .499-.583z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#007BED",
    fillRule: "evenodd",
    d: "M143 76.735a.57.57 0 0 0 .503.587c1.194.203 4.524.934 5.641 2.04 1.117 1.107 1.84 4.39 2.04 5.641a.6.6 0 0 0 .59.517v-8.781z",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      animation: "twinkle 3s infinite ease-in-out alternate",
      transformOrigin: "174px 63px"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#DABDFF",
    fillRule: "evenodd",
    d: "M189.302 63.758a1.045 1.045 0 0 0-.834-1.04c-2.044-.387-7.688-1.698-9.616-3.595s-3.231-7.54-3.599-9.616a1.03 1.03 0 0 0-1.036-.834v15.085z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#00B3F4",
    fillRule: "evenodd",
    d: "M174.3 48.673a1.02 1.02 0 0 0-1.013.865c-.349 2.032-1.613 7.583-3.526 9.639s-7.567 3.247-9.755 3.615a1.04 1.04 0 0 0-.846 1.04h15.128z",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#00B3F4",
    fillRule: "evenodd",
    d: "M174.217 63.758v15.085a1.08 1.08 0 0 0 1.028-.865c.368-2.067 1.703-7.792 3.599-9.697s7.545-3.157 9.593-3.491a1.03 1.03 0 0 0 .857-1.009z",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#007BED",
    fillRule: "evenodd",
    d: "M159.16 63.758a.998.998 0 0 0 .869 1.016c2.056.35 7.805 1.606 9.733 3.519 1.927 1.912 3.177 7.575 3.526 9.736a1.024 1.024 0 0 0 1.012.888V63.758z",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      animation: "twinkle 3.5s infinite ease-in-out alternate",
      transformOrigin: "156px 47px"
    }
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#DABDFF",
    fillRule: "evenodd",
    d: "M161.886 47.757a.4.4 0 0 0-.317-.397c-.783-.14-2.936-.646-3.67-1.373s-1.233-2.877-1.377-3.67a.39.39 0 0 0-.39-.317v5.757z",
    clipRule: "evenodd"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#00B3F4",
    fillRule: "evenodd",
    d: "M156.16 42.004a.4.4 0 0 0-.39.33c-.13.777-.614 2.895-1.341 3.678-.728.783-2.895 1.24-3.727 1.384a.395.395 0 0 0-.323.393h5.781z",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#00B3F4",
    fillRule: "evenodd",
    d: "M156.132 47.756v5.76a.415.415 0 0 0 .39-.33c.144-.79.65-2.974 1.377-3.709s2.88-1.204 3.66-1.334a.39.39 0 0 0 .327-.387z",
    clipRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#007BED",
    fillRule: "evenodd",
    d: "M150.379 47.756a.38.38 0 0 0 .333.39c.784.13 2.979.611 3.717 1.342.737.73 1.211 2.894 1.341 3.716a.396.396 0 0 0 .39.351v-5.799z",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_5165_11763)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 114.5,
    r: 22,
    fill: "#fff",
    style: {
      animation: "scaleCircle 2s ease-out 1",
      transformOrigin: "58px 115px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#1CC5A0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: "m57 115 7 7 14-14",
    style: {
      animation: "drawCheckmark 3s ease-in forwards"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5165_11763",
    width: 184,
    height: 132,
    x: 8,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.564706 0 0 0 0 0.929412 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5165_11763"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5165_11763",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_5165_11763",
    width: 115,
    height: 115,
    x: 0,
    y: 59,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.564706 0 0 0 0 0.929412 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5165_11763"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5165_11763",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGraphicRecoveryKeymin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/graphic_recovery_key.min.0b7f9b03796b53816b340d296d45535d.svg";